import React from "react";

const ItParkPartnership = () => {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* --- Background Pattern (Subtle Dots) --- */}
      <div className="absolute inset-0 w-full h-full z-0 opacity-[0.08]">
        <svg
          className="w-full h-full text-blue-600"
          viewBox="0 0 1440 800"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <defs>
            <pattern
              id="dots"
              patternUnits="userSpaceOnUse"
              width="40"
              height="40"
              patternTransform="rotate(45)"
            >
              <circle cx="10" cy="10" r="2" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="1440" height="800" fill="url(#dots)" />
        </svg>
      </div>

      {/* --- Main Content --- */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* --- Left Column: Text & Info --- */}
          <div className="flex flex-col gap-8">
            {/* Main Title */}
            <div>
              <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-4">
                Strategic Partnership
              </span>
              <h2 className="px-5 text-3xl lg:text-4xl font-extrabold text-slate-900 leading-tight">
                Official Representative of <br />
                <span className="text-blue-600">IT Park Uzbekistan</span>
              </h2>
            </div>

            {/* Description */}
            <div className="px-5 prose prose-lg text-slate-600">
              <p className="mb-4">
                Yarqin Tech Hub proudly holds official residency at IT Park
                Uzbekistan and serves as the first authorized representative of
                IT Park in Afghanistan. IT Park operates as a National Center
                for Innovation and Technology under the supervision of the
                Ministry of Digital Technologies of Uzbekistan.
              </p>
              <p>
                Through this official residency, we enable Afghan technology
                companies to gain access to rights, privileges, and support
                offered by IT Park Uzbekistan — particularly in technology,
                security, transparency, and international credibility.
              </p>
            </div>

            {/* Feature Cards (Stacked) */}
            <div className="space-y-4">
              {/* Card 1: Dedicated Team */}
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide">
                    Dedicated Team
                  </h3>
                  <p className="text-sm text-slate-500 mt-1">
                    Passionate experts committed to delivering excellence.
                  </p>
                </div>
              </div>

              {/* Card 2: Innovative Approach (Fixed Icon) */}
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide">
                    Innovative Approach
                  </h3>
                  <p className="text-sm text-slate-500 mt-1">
                    Crafting unique solutions tailored for your needs.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* --- Right Column: Image with Gradient Border --- */}
          <div className="relative group cursor-pointer">
            {/* Gradient Border Wrapper */}
            <div className="absolute -inset-1 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>

            {/* Inner Container (White Border) */}
            <div className="relative rounded-2xl bg-white p-1">
              <div className="relative rounded-xl overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0"
                  alt="IT Park Partnership"
                  className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
                />

                {/* Overlay Text on Image */}
                <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-black/80 to-transparent">
                  <p className="text-white font-bold text-lg">
                    Connecting Ecosystems
                  </p>
                  <p className="text-blue-100 text-sm">
                    Bridging Afghanistan & Uzbekistan
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItParkPartnership;
